import clsx from 'clsx'
import { useState } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowRight01Icon } from '@hugeicons/core-solid-rounded'
import { Trans } from '@lingui/react/macro'

import { StayOrders } from '@/features/order'

export default function OrdersField({ stayId }: { stayId: number }) {
  const [showOrder, setShowOrders] = useState(false)

  return (
    <div className="flex flex-1 flex-col gap-2.5 p-2.5">
      <button
        className="flex flex-row gap-2 cursor-pointer items-center"
        type="button"
        onClick={() => setShowOrders(show => !show)}
        tabIndex={0}
      >
        <HugeiconsIcon
          icon={ArrowRight01Icon}
          className={clsx(
            'size-4 text-text transition-transform',
            showOrder && 'rotate-90'
          )}
        />
        <h3 className="text-heading3 text-text">
          <Trans>Orders during the stay</Trans>
        </h3>
      </button>
      {showOrder && <StayOrders stayId={stayId} />}
    </div>
  )
}
